// extracted by mini-css-extract-plugin
export default {"headerContainer":"PageHeader_headerContainer__e+9-c","title":"PageHeader_title__YDhmh"};